import React from 'react'

// In V1 we use a <button> element for semantics, but it doesn’t have the normal
// “sites-button” styling.
export default function DropdownButton (props) {
  return <button>{props.children}</button>
}
